import { NgModule } from '@angular/core';
import { ProtocolSearchSelectComponent } from './upload-documents/category-upload-dialogs/form-fields/protocol-search-select.component';
import { CovanceAgGridModule } from '../covance-ag-grid/covance-ag-grid.module';
import { SharedModule } from '../shared';
import { CovanceFilterModule } from '../covance-filter';
import { GlobalPopupModule } from '../global-popup';
import { ReactiveFormsModule } from '@angular/forms';
import { CovanceFileUploadModule } from '../covance-file-upload/covance-file-upload.module';
import { CovanceTextFieldModule } from '../covance-textfield/covance-textfield.module';
import { UserModule } from '../user';
import { UserSearchSelectComponent } from './users/user-search-select.component';
import { AccessionSearchComponent, UserEmailsSearchComponent, UserEmailsStorage } from './shared';
import { ProtocolSearchFieldComponent } from './activity-reports/protocol-accesses/protocol-search-field/protocol-search-field.component';

@NgModule({
    declarations: [
        ProtocolSearchSelectComponent,
        UserSearchSelectComponent,
        AccessionSearchComponent,
        UserEmailsSearchComponent,
        ProtocolSearchFieldComponent,
    ],
    imports: [
        SharedModule,
        CovanceFilterModule,
        CovanceAgGridModule,
        GlobalPopupModule,
        ReactiveFormsModule,
        CovanceFileUploadModule,
        CovanceTextFieldModule,
        UserModule,
    ],
    exports: [
        ProtocolSearchSelectComponent,
        UserSearchSelectComponent,
        AccessionSearchComponent,
        UserEmailsSearchComponent,
        ProtocolSearchFieldComponent,
    ],
    providers: [
        UserEmailsStorage,
    ]
})
export class AdminSharedModule { }